/**
 * Functional Currency (REV-21512) is in BETA and offered to pilot organisations only, so the
 * activation control is hidden for everyone else.
 *
 * This is a FRONT-END guard rail, not an authorisation boundary: it hides the control, while
 * `PATCH /companies/:id/fx/activate` stays reachable for any org admin. Deliberate for the beta —
 * if it ever has to be airtight, the same list belongs in that endpoint's guard.
 *
 * Delete this list together with its use in `add-edit-company.page.ts` once FX is generally
 * available.
 */
export const FX_BETA_ORGANIZATION_IDS: readonly string[] = [
    '62be9d1a423fc4c111d18ef9', // BDO AG
    '61b9e183024633245baf0876', // Dr. Rietmann & Partner AG
    '6318376f3ac117e591d788bc', // Muster AG
    '6748895248c324641ba05177', // KENDRIS AG
    '66c2f4bda0e956b9c3bf8706', // Janosch
    '6a26913ebf77ea5fbe388a81', // Testing / Local seed
    '689206ea3b36437bfd9afe68', // PAT Ferox Org
    '688752e3e15188c2a7a80180',
];
